import { TweenLite, Power2 } from "gsap";

class Gallery {
  constructor(windowSizes) {
    this.duration = 1.5;
    this.windowSizes = windowSizes;

    this.activeImg = 0;
    this.containerWidth = 0;
    this.container = document.querySelector(".gallery-container");

    if (this.container) {
      this.inner = this.container.querySelector(".gallery");
      this.images = this.container.querySelectorAll(".gallery-item");
      this.legendContainer = this.container.querySelectorAll(
        ".gallery__legend"
      );

      this.totalImages = this.images.length;
      this.navLeft = this.container.querySelector(".gallery__nav__item--left");
      this.navRight = this.container.querySelector(
        ".gallery__nav__item--right"
      );
      this.init();
    }
  }

  init() {
    this.setSizes();
    this.initEvents();
    this.setCaption();
  }

  initEvents() {
    this.navLeft.addEventListener("click", () => {
      this.onLeft();
    });

    this.navRight.addEventListener("click", () => {
      this.onRight();
    });
  }

  onLeft() {
    const activeImg = this.activeImg;
    this.activeImg =
      activeImg - 1 === -1 ? this.totalImages - 1 : activeImg - 1;
    this.moveContainer(1);
    this.setCaption();
  }
  onRight() {
    const activeImg = this.activeImg;
    this.activeImg = activeImg + 1 === this.totalImages ? 0 : activeImg + 1;
    this.moveContainer(1);
    this.setCaption();
  }

  setCaption() {
    const caption = this.images[this.activeImg].querySelector(
      ".gallery-caption"
    ).textContent;
    this.legendContainer[0].innerHTML = caption;
  }

  moveContainer(duration) {
    TweenLite.to(this.inner, duration, {
      x: -this.containerWidth * this.activeImg + "px",
      ease: Power2.easeInOut,
      force3D: true
    });
  }

  setSizes() {
    const containerBounds = this.container.getBoundingClientRect();
    this.containerWidth = containerBounds.width;
    this.inner.style.width = this.totalImages * this.containerWidth + "px";

    Array.from(this.images, (image, index) => {
      image.style.width = this.containerWidth + "px";
      image.style.height = containerBounds.height + "px";
    });
    this.moveContainer(0);
  }

  /** Resize Event */
  resize(windowSizes) {
    this.windowSizes = windowSizes;
    if (this.container) {
      this.setSizes();
    }
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/js/components/Gallery.js